import {SizeSelection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useCallback} from 'react';

export const useGetFirstAvailableSizeCallback = () => {
  return useCallback((sizeSelection: SizeSelection['type']) => {
    switch (sizeSelection?.$case) {
      case 'sizeRuns': {
        return sizeSelection.sizeRuns.sizeRuns[0]?.sizes[0] ?? null;
      }
      case 'sizes': {
        return sizeSelection?.sizes.sizes[0] ?? null;
      }
      case 'inlineSelection': {
        return sizeSelection?.inlineSelection.sizes[0] ?? null;
      }
      case 'oneSize': {
        return sizeSelection.oneSize.size;
      }
      case 'groupedSizes': {
        const size = sizeSelection?.groupedSizes.groups[0]?.content;
        switch (size?.$case) {
          case 'sizeRuns': {
            return size.sizeRuns.sizeRuns[0]?.sizes[0] ?? null;
          }
          case 'sizes': {
            return size.sizes.sizes[0] ?? null;
          }
          default:
            return null;
        }
      }
      default:
        return null;
    }
  }, []);
};
